import React from "react";

const NavbarMenuToggle = React.forwardRef((props: { children: React.ReactNode, onClick?: React.MouseEventHandler<HTMLButtonElement>, showArrow?: boolean }, ref: React.ForwardedRef<HTMLButtonElement>) => (
    <button type="button" className="link-button" ref={ref}
        onClick={(e) => { e.preventDefault(); props.onClick?.(e); }}>
        {props.children}
        {props.showArrow && <>&#x25bc;</>}
    </button>
));

export default NavbarMenuToggle;